import { useEffect, useState } from "react";
import axios from 'axios';
import { useNavigate, Link, useParams, useSearchParams } from "react-router-dom";
import AlertMessage from "../include/AlertMessage";
var _ = require('lodash');


function EditCategory() {
    const [searchParams] = useSearchParams();
    const page = searchParams.get("page") || 1;

    const [alert, setAlert] = useState({ type: "", message: "" });
    const [formData, setFormData] = useState({ name: '', icon: '', colorCode: '' });
    const [errors, setErrors] = useState({});
    const redirectHistory = useNavigate();
    const { id } = useParams();
    const token = sessionStorage.getItem('JWT_TOKEN');
    const [loading, setLoading] = useState(true);

    const validate = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = "Name is required.";
        if (!formData.icon) newErrors.icon = "Icon is required.";
        if (!formData.colorCode) newErrors.colorCode = "Color Code is required.";
        return newErrors;
    };

    // Define an async function inside useEffect
    const fetchCategoryDetail = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/fetchCategoryDetail/${id}`, {
                headers: {
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });


            const resdata = response.data.data;
            const customdata = {
                name: resdata.name,
                icon: resdata.icon,
                colorCode: resdata.colorCode
            }
            setFormData(customdata); // Set data to state                
        } catch (error) {
            const apierror = _.get(error, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        }
    };


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };


    useEffect(() => {
        document.documentElement.className = "";

        fetchCategoryDetail();
    }, [id]);

    const handleEdit = async (e) => {
        e.preventDefault();
        const newErrors = validate();
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            try {
                const colorCode = formData.colorCode.startsWith("#")
                    ? formData.colorCode
                    : `#${formData.colorCode}`;

                //API URL
                const response = await axios.put(`${process.env.REACT_APP_API_URL}/editcategory/${id}`, {
                    "name": formData.name,
                    "icon": formData.icon,
                    colorCode
                },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token // Replace with your token
                        }
                    }
                );

                if (response.status === 200 || response.status === 201) {
                    setAlert({ type: "success", message: "Category updated successfully." });
                    setTimeout(() => {
                        redirectHistory(`/categories?page=${page}`);
                    }, 2500);
                }

            } catch (err) {
                const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Failed to edit category. Please try again.");
                setAlert({ type: "error", message: apierror });
            }

        }
    }

    return (
        <section>
            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
                        <li><Link to="/categories" className='btn btn-primary'>Categories</Link></li>
                        <li>Edit Category</li>
                    </ul>
                </div>
            </div>
            <div className="section main-section">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                                Edit Category
                            </p>
                        </header>
                        <div className="card-content">
                            {loading ? (
                                <div className="flex justify-center items-center py-10">
                                    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                                </div>

                            ) : (
                                <form onSubmit={handleEdit}>
                                    {alert.message && (
                                        <AlertMessage
                                            type={alert.type}
                                            message={alert.message}
                                            onClose={() => setAlert({ type: "", message: "" })}
                                        />
                                    )}
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label" htmlFor="name">Name <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" id="name" type="text" placeholder="Name" name="name" value={formData.name} onChange={handleChange} />
                                            </div>
                                            {errors.name && <p className="help" style={{ color: 'red' }}>{errors.name}</p>}
                                        </div>
                                    </div>
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label" htmlFor="icon">Icon <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" id="icon" type="text" placeholder="Icon" name="icon" value={formData.icon} onChange={handleChange} />
                                                <br /> <small>Use any icon from <a href="https://oblador.github.io/react-native-vector-icons/#MaterialIcons" target="_blank" rel="noopener noreferrer">Material Icons</a>. Just copy the class name. For example, for "Add call", enter "add-call".</small>
                                            </div>
                                            {errors.icon && <p className="help" style={{ color: 'red' }}>{errors.icon}</p>}
                                        </div>
                                        <div className="field">
                                            <label className="label" htmlFor="colorCode">Color Code <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" id="colorCode" type="text" placeholder="Color Code" name="colorCode" value={formData.colorCode} onChange={handleChange} />
                                                <br /> <small>Enter a valid hex color code. For example, #FF5733.</small>
                                            </div>
                                            {errors.colorCode && <p className="help" style={{ color: 'red' }}>{errors.colorCode}</p>}
                                        </div>
                                    </div>



                                    <div className="flex justify-center items-center">
                                        <div className="field grouped">
                                            <div className="control">
                                                <button type="submit" className="button green">
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </section>
    )
}

export default EditCategory;
